/**
 * WW-0017_PDP — add-to-cart upsell popup.
 * Search the theme for WW-0017_PDP to remove this test.
 *
 * Add-to-cart upsell popup.
 *
 * Stays off unless a test assigns a variation. Control keeps the existing
 * "Beliebt bei unseren Kunden" popup.
 *
 * Variation 1 (slider):  window.SH_ATC_VARIATION = '1'   or  ?sh_atc=1
 * Variation 2 (stack):   window.SH_ATC_VARIATION = '2'   or  ?sh_atc=2
 * Preview the sheet:     add &sh_atc_preview=1
 */
(function () {
  var root = document.getElementById('sh-atc-popup');
  if (!root || !window.themeVariables) return;

  var scroller = root.querySelector('[data-sh-atc-scroller]');
  var track = root.querySelector('[data-sh-atc-track]');
  var swiper = null;
  var dotsWrap = root.querySelector('[data-sh-atc-dots]');
  var fade = root.querySelector('[data-sh-atc-fade]');
  var prevBtn = root.querySelector('[data-sh-atc-prev]');
  var nextBtn = root.querySelector('[data-sh-atc-next]');
  var sheetBody = root.querySelector('[data-sh-atc-body]');
  var countEl = root.querySelector('[data-sh-atc-count]');
  var addedList = root.querySelector('[data-sh-atc-added-list]');
  var closeBtn = root.querySelector('.sh-atc-popup__close');

  var lastAdded = null;
  var sessionAdds = [];
  var pendingAdd = false;
  var pendingAt = 0;
  var suppressDrawerUntil = 0;
  var allowDrawer = false;
  var drawerTimers = [];
  var layout = 'slider';
  var cartVariants = {};
  var addedUpsellThisOpen = false;

  // WW-0017_PDP — two closes in this browser session with no upsell add hide the popup.
  var DISMISS_KEY = 'ww-0017-pdp-dismiss-count';
  var DISMISS_LIMIT = 2;

  function dismissCount() {
    try {
      return Number(window.sessionStorage.getItem(DISMISS_KEY)) || 0;
    } catch (error) {
      return 0;
    }
  }

  function popupSuppressed() {
    return dismissCount() >= DISMISS_LIMIT;
  }

  function noteDismiss() {
    if (addedUpsellThisOpen) return;
    try {
      window.sessionStorage.setItem(DISMISS_KEY, String(dismissCount() + 1));
    } catch (error) {}
  }

  function modeFromUrl() {
    var value = new URLSearchParams(window.location.search).get('sh_atc');
    if (!value && window.SH_ATC_VARIATION != null && window.SH_ATC_VARIATION !== '') {
      value = String(window.SH_ATC_VARIATION);
    }
    value = (value || '').toLowerCase();
    if (value === '1' || value === 'b' || value === 'slider') return 'slider';
    if (value === '2' || value === 'c' || value === 'stack') return 'stack';
    return 'off';
  }

  function applyLayout() {
    var mode = modeFromUrl();
    layout = mode === 'stack' ? 'stack' : 'slider';
    root.classList.toggle('sh-atc-popup--slider', mode === 'slider');
    root.classList.toggle('sh-atc-popup--stack', mode === 'stack');
    if (mode === 'off') return;
    window.requestAnimationFrame(syncChrome);
  }

  function markVariation() {
    var mode = modeFromUrl();
    var on = mode !== 'off';
    document.documentElement.classList.toggle('sh-atc-variation', on);
    if (!on) return false;
    var want = mode === 'stack' ? 'sh-atc-popup--stack' : 'sh-atc-popup--slider';
    if (!root.classList.contains(want)) applyLayout();
    return true;
  }

  // WW-0017_PDP — CandyRack ("Beliebt bei unseren Kunden") is the control.
  // It clones the add button and swallows the first click to open itself.
  // A variation must let that click reach the theme, then hide CandyRack's frame.
  function releaseAddButton() {
    var rack = window.CandyRack;
    if (rack && rack.buttonState === 'idle') rack.buttonState = 'pass-through';
    var buttons = document.querySelectorAll('#AddToCart, #StickyAddToCart, form[action*="/cart/add"] button[type="submit"], .candy-cloned');
    Array.prototype.forEach.call(buttons, function (button) {
      button.classList.add('cr-ignore');
    });
  }

  // WW-0017_PDP — cr-ignore also stops CandyRack's PDP checkbox block
  // ("Ergänze dein passendes Zubehör"), which rides on the store button.
  // The test is only about the popup, so in a variation we add the ticked
  // PDP upsells ourselves, from CandyRack's own block state.
  function selectedPdpUpsells() {
    var blocks = (window.CandyRackAppBlocks && window.CandyRackAppBlocks.blocks) || {};
    var items = [];
    Object.keys(blocks).forEach(function (key) {
      var block = blocks[key];
      if (!block || block.blockLayout !== 'checkbox') return;
      if (block.settings && block.settings.button_location && block.settings.button_location !== 'store_button') return;
      (block.offers || []).forEach(function (offer) {
        (offer.items || []).forEach(function (item) {
          if (!item || !item.isSelected || !item.selectedVariantId) return;
          var line = { id: Number(item.selectedVariantId), quantity: Number(item.selectedVariantQuantity) || 1 };
          if (item.note) line.properties = { note: item.note };
          items.push(line);
        });
      });
    });
    return items;
  }

  function addPdpUpsells() {
    if (modeFromUrl() === 'off') return Promise.resolve(null);
    var items = selectedPdpUpsells();
    if (!items.length) return Promise.resolve(null);
    return postCart(window.themeVariables.routes.cartAddUrl + '.js', {
      items: items,
      sections: 'mini-cart'
    }).then(function (data) {
      if (window.CandyRackAppBlocks) {
        window.CandyRackAppBlocks.variantIdsInCart = items.map(function (line) { return line.id; });
      }
      (data.items || []).forEach(function (item) {
        var id = String(item.variant_id);
        var exists = sessionAdds.some(function (extra) { return extra.id === id; });
        if (exists) return;
        sessionAdds.push({
          id: id,
          title: item.product_title || item.title || '',
          variantLabel: variantLabelOf(item),
          image: imageSrc(item),
          price: itemPrice(item)
        });
      });
      return refreshCart(data.sections);
    }).then(function (cart) {
      renderAdded(cart);
      syncButtons();
      return cart;
    }).catch(function (error) {
      if (window.console) window.console.warn('[WW-0017_PDP] PDP upsells not added:', error);
      return null;
    });
  }

  function hideCandyFrame() {
    if (!markVariation()) return;
    releaseAddButton();
    if (document.body) document.body.classList.remove('candyrack-body-open');
    var frame = document.getElementById('candyrack-frame');
    if (!frame || frame.hidden) return;
    frame.hidden = true;
    frame.style.setProperty('display', 'none', 'important');
  }

  function formatMoney(cents) {
    var format = window.themeVariables.settings.moneyFormat || '€{{amount}}';
    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = placeholder ? placeholder[1] : 'amount';
    var amount = (Number(cents) / 100).toFixed(2);
    var formatted = amount;
    if (key.indexOf('comma_separator') !== -1) {
      var parts = amount.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      formatted = key.indexOf('no_decimals') !== -1 ? whole : whole + ',' + parts[1];
    } else if (key.indexOf('apostrophe_separator') !== -1) {
      formatted = amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    } else if (key === 'amount_no_decimals') {
      formatted = String(Math.round(Number(cents) / 100));
    }
    return placeholder ? format.replace(placeholder[0], formatted) : formatted;
  }

  function imageSrc(item) {
    if (!item) return '';
    var src = '';
    if (typeof item.image === 'string') src = item.image;
    else if (item.image && item.image.src) src = item.image.src;
    else if (item.featured_image && item.featured_image.url) src = item.featured_image.url;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src;
  }

  function itemPrice(item) {
    if (!item) return 0;
    if (typeof item.final_price === 'number') return item.final_price;
    return item.price || 0;
  }

  function setCount(count) {
    if (countEl) countEl.textContent = String(count);
  }

  function variantLabelOf(item) {
    if (!item) return '';
    var label = item.variant_title || item.variantLabel || '';
    if (!label || label === 'Default Title') return '';
    return String(label).split(' / ').filter(function (part) {
      return part.trim().toLowerCase() !== 'ohne name';
    }).join(' / ');
  }

  function appendAddedRow(row) {
    var el = document.createElement('div');
    el.className = 'sh-atc-popup__added' + (row.badge ? ' sh-atc-popup__added--extra' : '');

    var image = document.createElement('img');
    image.className = 'sh-atc-popup__added-image';
    image.alt = row.title || '';
    image.width = 48;
    image.height = 48;
    if (row.image) image.src = row.image;
    else image.hidden = true;

    var copy = document.createElement('div');
    copy.className = 'sh-atc-popup__added-copy';

    var title = document.createElement('p');
    title.className = 'sh-atc-popup__added-title';
    title.textContent = row.title || '';
    copy.appendChild(title);

    if (row.variantLabel) {
      var variant = document.createElement('p');
      variant.className = 'sh-atc-popup__added-variant';
      variant.textContent = row.variantLabel;
      copy.appendChild(variant);
    }

    if (row.badge) {
      var badge = document.createElement('p');
      badge.className = 'sh-atc-popup__added-badge';
      badge.textContent = 'Gerade hinzugefügt';
      copy.appendChild(badge);
    }

    var price = document.createElement('p');
    price.className = 'sh-atc-popup__added-price';
    price.textContent = formatMoney(row.price || 0);

    el.appendChild(image);
    el.appendChild(copy);
    el.appendChild(price);
    addedList.appendChild(el);
  }

  function renderAdded(cart) {
    if (!addedList) return;
    var primary = lastAdded;
    if (cart && primary && primary.variant_id) {
      (cart.items || []).some(function (item) {
        if (String(item.variant_id) !== String(primary.variant_id)) return false;
        primary = item;
        return true;
      });
    }

    var rows = [];
    if (primary && (primary.product_title || primary.title)) {
      var primaryId = primary.variant_id;
      var stillInCart = !cart || !primaryId || !!cartVariants[String(primaryId)];
      if (stillInCart) {
        rows.push({
          title: primary.product_title || primary.title,
          variantLabel: variantLabelOf(primary),
          image: imageSrc(primary),
          price: itemPrice(primary),
          badge: false
        });
      }
    }

    sessionAdds.forEach(function (extra) {
      if (cart && !cartVariants[String(extra.id)]) return;
      rows.push({
        title: extra.title,
        variantLabel: extra.variantLabel,
        image: extra.image,
        price: extra.price,
        badge: true
      });
    });

    addedList.innerHTML = '';
    if (!rows.length) {
      addedList.hidden = true;
      return;
    }
    rows.forEach(appendAddedRow);
    addedList.hidden = false;
  }

  function snapshotAdd(button, variantId) {
    var card = cardOf(button);
    var select = selectOf(button);
    var option = select && select.options[select.selectedIndex];
    var titleEl = card && card.querySelector('.sh-atc-popup__card-title');
    var imageEl = card && card.querySelector('[data-sh-atc-image]');
    var priceEl = card && card.querySelector('[data-sh-atc-price]');
    var cents = (option && option.getAttribute('data-price-cents')) || (priceEl && priceEl.getAttribute('data-price-cents')) || 0;
    return {
      id: String(variantId),
      title: titleEl ? titleEl.textContent.trim() : '',
      variantLabel: option && option.value ? option.textContent.trim() : '',
      image: (option && option.getAttribute('data-image')) || (imageEl ? imageEl.src : ''),
      price: Number(cents)
    };
  }

  function rememberSession(snapshot) {
    if (!snapshot || !snapshot.id) return;
    addedUpsellThisOpen = true;
    var exists = sessionAdds.some(function (extra) {
      return extra.id === snapshot.id;
    });
    if (!exists) sessionAdds.push(snapshot);
  }

  function sliderCards() {
    return scroller.querySelectorAll('.sh-atc-popup__card');
  }

  function buildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    Array.prototype.forEach.call(sliderCards(), function (card, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sh-atc-popup__dot';
      dot.setAttribute('aria-label', 'Produkt ' + (index + 1));
      dot.addEventListener('click', function () {
        if (swiper) swiper.slideTo(index);
      });
      dotsWrap.appendChild(dot);
    });
  }

  function syncSlider() {
    if (layout !== 'slider' || !swiper) return;
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.sh-atc-popup__dot') : [];
    var index = swiper.isEnd ? dots.length - 1 : swiper.activeIndex;
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
    if (prevBtn) prevBtn.disabled = swiper.isBeginning;
    if (nextBtn) nextBtn.disabled = swiper.isEnd;
  }

  function unmountSlider() {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
    scroller.classList.remove('swiper');
    if (track) track.classList.remove('swiper-wrapper');
    Array.prototype.forEach.call(sliderCards(), function (card) {
      card.classList.remove('swiper-slide');
    });
  }

  function mountSlider() {
    if (layout !== 'slider' || !window.Swiper || !track) return;
    if (swiper) {
      swiper.update();
      syncSlider();
      return;
    }
    scroller.classList.add('swiper');
    track.classList.add('swiper-wrapper');
    Array.prototype.forEach.call(sliderCards(), function (card) {
      card.classList.add('swiper-slide');
    });
    swiper = new window.Swiper(scroller, {
      slidesPerView: 2.2,
      spaceBetween: 10,
      speed: 450,
      resistanceRatio: 0.65,
      threshold: 6,
      watchOverflow: true,
      roundLengths: false,
      resizeObserver: false,
      updateOnWindowResize: true,
      on: {
        slideChange: syncSlider,
        reachEnd: syncSlider,
        reachBeginning: syncSlider,
        fromEdge: syncSlider
      }
    });
    syncSlider();
  }

  function syncFade() {
    if (!fade || !sheetBody) return;
    if (layout !== 'stack') {
      fade.hidden = true;
      return;
    }
    var canScroll = sheetBody.scrollHeight > sheetBody.clientHeight + 4;
    var atEnd = sheetBody.scrollTop + sheetBody.clientHeight >= sheetBody.scrollHeight - 8;
    fade.hidden = !canScroll || atEnd;
  }

  function syncChrome() {
    if (scroller) scroller.style.maxHeight = '';
    syncFade();
    syncSlider();
  }

  function openPopup(cart) {
    applyLayout();
    if (modeFromUrl() === 'off' || popupSuppressed()) return;
    addedUpsellThisOpen = false;
    if ((!lastAdded || !(lastAdded.product_title || lastAdded.title)) && cart && cart.items && cart.items.length) {
      lastAdded = cart.items[cart.items.length - 1];
    }
    renderAdded(cart);
    if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
    refreshCart().then(function (nextCart) {
      renderAdded(nextCart);
      primeSelections();
      syncChrome();
    });
    blockSideCart();
    if (root.parentElement !== document.body) document.body.appendChild(root);
    root.hidden = false;
    document.body.classList.add('sh-atc-popup-open');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (layout === 'slider') mountSlider();
        else unmountSlider();
        syncChrome();
        if (closeBtn) closeBtn.focus();
      });
    });
  }

  function closePopup(silent) {
    if (root.hidden) return;
    if (!silent) noteDismiss();
    root.hidden = true;
    document.body.classList.remove('sh-atc-popup-open');
    drawerTimers.forEach(window.clearTimeout);
    drawerTimers = [];
  }

  function cardOf(button) {
    return button.closest('.sh-atc-popup__card');
  }

  function selectOf(button) {
    var card = cardOf(button);
    return card ? card.querySelector('[data-sh-atc-select]') : null;
  }

  function realOptions(select) {
    return Array.prototype.filter.call(select.options, function (option) {
      return option.value;
    });
  }

  function selectedId(button) {
    var select = selectOf(button);
    if (select) return select.value || '';
    return button.getAttribute('data-variant-id') || '';
  }

  function variantToAdd(button) {
    var select = selectOf(button);
    if (select) {
      if (select.value) return select.value;
      var first = realOptions(select)[0];
      return first ? first.value : '';
    }
    return button.getAttribute('data-variant-id') || '';
  }

  function nextFreeOption(select, afterId) {
    var options = realOptions(select);
    if (!options.length) return null;
    var start = 0;
    if (afterId) {
      options.forEach(function (option, index) {
        if (option.value === String(afterId)) start = index + 1;
      });
    }
    for (var step = 0; step < options.length; step += 1) {
      var candidate = options[(start + step) % options.length];
      if (!cartVariants[candidate.value]) return candidate;
    }
    return null;
  }

  function applyOptionVisuals(select) {
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var card = select.closest('.sh-atc-popup__card');
    if (!card || !option || !option.value) return;
    var image = card.querySelector('[data-sh-atc-image]');
    var price = card.querySelector('[data-sh-atc-price]');
    if (image && option.getAttribute('data-image')) image.src = option.getAttribute('data-image');
    if (price && option.getAttribute('data-price-cents')) {
      price.textContent = formatMoney(option.getAttribute('data-price-cents'));
      price.setAttribute('data-price-cents', option.getAttribute('data-price-cents'));
    }
  }

  function rememberCart(cart) {
    cartVariants = {};
    (cart.items || []).forEach(function (item) {
      cartVariants[String(item.variant_id)] = { key: item.key, quantity: item.quantity };
    });
  }

  function syncButton(button) {
    var id = selectedId(button);
    var inCart = !!(id && cartVariants[id]);
    button.classList.toggle('is-remove', inCart);
    button.setAttribute('aria-label', inCart ? button.getAttribute('data-remove-label') : button.getAttribute('data-add-label'));
  }

  function syncButtons() {
    root.querySelectorAll('[data-sh-atc-add]').forEach(syncButton);
  }

  function primeSelections() {
    root.querySelectorAll('[data-sh-atc-select]').forEach(function (select) {
      if (!select.value || !cartVariants[select.value]) return;
      var next = nextFreeOption(select, select.value);
      if (!next) return;
      select.value = next.value;
      applyOptionVisuals(select);
    });
    syncButtons();
  }

  function setLoading(button, loading) {
    button.classList.toggle('is-loading', loading);
    button.disabled = loading;
    if (loading) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function postCart(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var message = data.description || data.message || 'Nicht verfügbar';
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function refreshCart(sections) {
    var cartUrl = window.themeVariables.routes.cartUrl + '.js';
    return fetch(cartUrl, { cache: 'no-store' }).then(function (response) {
      return response.json();
    }).then(function (cart) {
      if (sections) cart.sections = sections;
      rememberCart(cart);
      setCount(cart.item_count);
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart, openMiniCart: false }
      }));
      return cart;
    });
  }

  function addVariant(button) {
    var variantId = variantToAdd(button);
    if (!variantId || button.disabled || button.classList.contains('is-remove')) return;
    var snapshot = snapshotAdd(button, variantId);
    setLoading(button, true);
    postCart(window.themeVariables.routes.cartAddUrl + '.js', {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: 'mini-cart'
    }).then(function (data) {
      return refreshCart(data.sections);
    }).then(function (cart) {
      rememberSession(snapshot);
      var select = selectOf(button);
      if (select) {
        var next = nextFreeOption(select, variantId);
        select.value = next ? next.value : String(variantId);
        applyOptionVisuals(select);
      }
      renderAdded(cart);
      syncButtons();
    }).catch(function (error) {
      button.setAttribute('aria-label', error.message);
    }).finally(function () {
      setLoading(button, false);
    });
  }

  function removeVariant(button) {
    var variantId = selectedId(button);
    var line = cartVariants[variantId];
    if (!line || button.disabled) return;
    setLoading(button, true);
    postCart(window.themeVariables.routes.cartChangeUrl + '.js', {
      id: line.key,
      quantity: 0,
      sections: 'mini-cart'
    }).then(function (data) {
      return refreshCart(data.sections);
    }).then(function (cart) {
      sessionAdds = sessionAdds.filter(function (extra) {
        return extra.id !== String(variantId);
      });
      renderAdded(cart);
      syncButtons();
    }).catch(function (error) {
      button.setAttribute('aria-label', error.message);
    }).finally(function () {
      setLoading(button, false);
    });
  }

  function closeSideCart() {
    if (allowDrawer) return;
    var drawer = document.getElementById('mini-cart');
    if (drawer) drawer.open = false;
  }

  function blockSideCart() {
    allowDrawer = false;
    suppressDrawerUntil = Date.now() + 10000;
    drawerTimers.forEach(window.clearTimeout);
    drawerTimers = [0, 50, 400, 800].map(function (delay) {
      return window.setTimeout(closeSideCart, delay);
    });
    closeSideCart();
  }

  function openSideCart() {
    allowDrawer = true;
    drawerTimers.forEach(window.clearTimeout);
    drawerTimers = [];
    closePopup();
    var drawer = document.getElementById('mini-cart');
    if (drawer) drawer.open = true;
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-sh-atc-cart]')) {
      event.preventDefault();
      openSideCart();
      return;
    }
    if (event.target.closest('[data-sh-atc-close]')) {
      event.preventDefault();
      closePopup();
      return;
    }
    var add = event.target.closest('[data-sh-atc-add]');
    if (!add) return;
    event.preventDefault();
    event.stopPropagation();
    if (add.classList.contains('is-remove')) removeVariant(add);
    else addVariant(add);
  });

  root.addEventListener('change', function (event) {
    var select = event.target.closest('[data-sh-atc-select]');
    if (!select) return;
    applyOptionVisuals(select);
    var card = select.closest('.sh-atc-popup__card');
    var button = card && card.querySelector('[data-sh-atc-add]');
    if (button) syncButton(button);
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      if (swiper) swiper.slidePrev();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (swiper) swiper.slideNext();
    });
  }
  if (scroller) {
    scroller.addEventListener('scroll', syncSlider, { passive: true });
  }
  if (sheetBody) {
    sheetBody.addEventListener('scroll', syncFade, { passive: true });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) closePopup();
  });

  // Pre-order cart guard: its sheet takes over from this popup, and its undo removes the product
  // listed here. Neither is the customer closing the popup, so it does not count as a dismiss.
  document.addEventListener('sh-po-guard:close-upsell', function () {
    closePopup(true);
  });

  document.addEventListener('variant:added', function (event) {
    hideCandyFrame();
    lastAdded = event.detail && event.detail.variant;
    sessionAdds = [];
    pendingAdd = true;
    pendingAt = Date.now();
    if (modeFromUrl() !== 'off' && window.themeVariables.settings.pageType !== 'cart') {
      pendingAdd = false;
      if (!popupSuppressed()) openPopup(null);
    }
    addPdpUpsells();
  }, true);

  window.setInterval(function () {
    if (modeFromUrl() === 'off') return;
    hideCandyFrame();
  }, 250);

  document.documentElement.addEventListener('cart:refresh', function (event) {
    if (popupSuppressed()) {
      pendingAdd = false;
      suppressDrawerUntil = 0;
      drawerTimers.forEach(window.clearTimeout);
      drawerTimers = [];
      return;
    }
    var blockDrawer = !allowDrawer && modeFromUrl() !== 'off' && Date.now() < suppressDrawerUntil;
    if (blockDrawer && event.detail) event.detail.openMiniCart = false;
    if (!pendingAdd || Date.now() - pendingAt > 10000) return;
    if (modeFromUrl() === 'off') return;
    if (window.themeVariables.settings.pageType === 'cart') return;
    pendingAdd = false;
    if (event.detail) event.detail.openMiniCart = false;
    openPopup(event.detail && event.detail.cart);
  }, true);

  window.addEventListener('resize', syncChrome);
  applyLayout();
  buildDots();

  if (new URLSearchParams(window.location.search).get('sh_atc_preview') === '1') {
    openPopup({ item_count: 1, items: [] });
  }
})();
